import Audiences from './Audiences.Container';

export default Audiences;
